import { cn } from '@/services/utils';

function Skeleton({ className, animated = true, ...props }: React.ComponentProps<'div'> & { animated?: boolean }) {
  return (
    <div
      data-slot="skeleton"
      aria-hidden="true"
      className={cn(
        'rounded-full bg-slate-100',
        animated &&
          'animate-shimmer bg-[length:300%_100%] bg-gradient-to-r from-slate-100 via-slate-200 to-slate-100',
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
